<template>
  <template v-if="reviews && reviews.length > 0">
    <TTitle size="2xl">Opiniones de Google</TTitle>
    <TGrid :gap-y="8" class="s-reviews">
      <div v-for="(item, index) in reviews" :key="index" class="col-span-12">
        <TReviewGoogle v-bind="item" />
      </div>
    </TGrid>
  </template>
</template>

<script setup lang="ts">
import { type Props } from '~~/modules/design-system/components/t-review-google/index.vue'

export interface propsInterface {
  reviews: Array<Props>
}

withDefaults(defineProps<propsInterface>(), {})
</script>
